import React, { Component, Fragment } from 'react'
import { css, StyleSheet } from 'aphrodite';
import { AppTheme, AppStyles } from '../../styles/AppTheme';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Checkbox from '@material-ui/core/Checkbox';
import { NextPage } from '../components/NextPage'
import { CircularProgress, Tooltip } from '@material-ui/core';
import { Helper } from '../helpers/Helper';
import { MenuItemsDropdown } from './MenuItemsDropdown';
import { CustomTableComponentStyles } from '../../styles/CustomStyles';
import { AppConfig } from '../../AppConfig';
import { AppHelper } from '../../helpers/AppHelper';
import { UiHelper } from '../helpers/UiHelper';
import { Droppable, Draggable } from 'react-beautiful-dnd';

export class TableComponent extends Component {
  constructor(props) {
    super(props)
    // console.log(props)
    this.state = {
      checkedAll:false
    }
  }

  // Fix for slowness in UI when the table list grows bigger
  // shouldComponentUpdate(nextProps) {
  //   // Shallow comparison of rows prop
  //   return nextProps.items !== this.props.items;
  // }

  renderHeadActions(cellWidths) {
    return (
      <TableCell className={css([Styles.cellHead, cellWidths.actions])}>
      </TableCell>
    )
  }

  renderHead() {
    if (this.props.noTableHead) return null
    const { tableHeadersMap } = this.props
    const tableHeaders = tableHeadersMap ? Object.keys(tableHeadersMap) : this.props.tableHeaders
    const cellWidths = this.props.cellWidths || {}
    return (
      <TableHead>
        <TableRow>
          {tableHeaders.map((header, index) => (
            <TableCell
              className={(index === 0) ? css([Styles.cellHead, Styles.firstcellBody, cellWidths[header]]) : css([Styles.cellHead, cellWidths[header]])}
              key={'headCol' + index}>{header}
            </TableCell>
          ))}
          {this.renderHeadActions(cellWidths)}
        </TableRow>
      </TableHead>
    )
  }

  renderBodyActions(current, itemIndex, cellWidths) {
    return (
      <TableCell className={css([Styles.cellBody, this.props.bodyCellStyle, Styles.cellBodyIcons, cellWidths.actions])}>
        <div className={css(Styles.divIcon)}>
          {this.setUpActions(current, itemIndex)}
          {this.setUpMenuItems(current, itemIndex)}
        </div>
      </TableCell>
    )
  }

  _getTableRows(options = {}) {
    const {
      current,
      provided = {
        innerRef: null, draggableProps: {}, dragHandleProps: {}
      },
      snapshot = { isDragging: false },
      tableHeaders, tableHeadersMap, checkedItems, itemIndex, cellWidths, onTableValue } = options
    return (
      <TableRow key={current.id} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} className={(snapshot.isDragging) ? css(Styles.draggingRow) : ''}>
        {this.props.displayCheckBoxTable && this.props.checkBoxActions(checkedItems).length > 0 && this.renderCheckbox(current, itemIndex)}
        {tableHeaders.map((f, headerIndex) => (
          <TableCell key={current.id + headerIndex}
            className={(headerIndex === 0 && !this.props.displayCheckBoxTable) ? css([Styles.cellBody, this.props.bodyCellStyle, Styles.firstcellBody, cellWidths[f]]) : css([Styles.cellBody, this.props.bodyCellStyle])}
          >
            {tableHeadersMap ? tableHeadersMap[f](current) : onTableValue(current, headerIndex)}
          </TableCell>
        ))}
        {this.renderBodyActions(current, itemIndex, cellWidths)}
        {/* {this.renderCheckbox(current, itemIndex)} */}
      </TableRow>
    )
  }
  renderBody() {
    const { tableHeadersMap, onTableValue, items } = this.props
    const tableHeaders = tableHeadersMap ? Object.keys(tableHeadersMap) : this.props.tableHeaders
    const lastElmntIndex = this.props.tableHeaders ? this.props.tableHeaders.length - 1 : undefined;
    const cellWidths = this.props.cellWidths || {}
    const checkedItems = (this.props.allItems || this.props.items || []).filter(item => item._selected === true)
    if(this.props.droppableTableId) {
      return (
        <TableBody className={css((this.props.isDragEnabled && items.length === 0) ? Styles.emptyTableDnd : '')}>
          {this.renderHeaderAction(tableHeaders)}
          {
            items.map((current, itemIndex) => {
              current.__index = itemIndex
              return (
                <Draggable isDragDisabled={this.props.isDragEnabled ? false : true} key={current.id} draggableId={String(current.id)} index={itemIndex}>
                  {(provided, snapshot) => (
                    <Fragment>
                      {!current._loading ?
                        this._getTableRows({ current, provided, snapshot, tableHeaders, tableHeadersMap, checkedItems, itemIndex, cellWidths, onTableValue})
                        :
                        <TableRow key={current.id} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} className={snapshot.isDragging ? css(Styles.draggingRow) : ''}>
                          <TableCell key={current.id + 'new_item'} className={css(Styles.cellBody, Styles.fullCellBodyLoader)} colSpan={tableHeaders.length + 1 }>
                            <CircularProgress />
                          </TableCell>
                        </TableRow>
                      }
                    </Fragment>
                  )}
                </Draggable>
              )
            })
          }
          {/* Incase of drag enable show droppable no data message */}
          {items.length === 0 && (
            <Draggable isDragDisabled={true} key={'EmptyTable'} draggableId={String('EmptyTableId')} index={'EmptyTable'}>
              {(provided, snapshot) => (
                <TableRow key={'EmptyTableId'} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                  <TableCell key={'EmptyTableIdCell' + Math.floor(Math.random() * 9999)} className={css(Styles.cellBody, Styles.fullCellBodyLoader)}>
                    <div className={css(Styles.emptyMessageDnd)}>{Helper.getString('emptyMsg')}</div>
                  </TableCell>
                </TableRow>
              )}
            </Draggable>
          )}
        </TableBody >
      )
    } else {
      return (
        <TableBody>
          {this.renderHeaderAction(tableHeaders)}
          {
            items.map((current, itemIndex) => {
              current.__index = itemIndex
              return (
                <Fragment>
                  {this._getTableRows({ current, tableHeaders, tableHeadersMap, checkedItems, itemIndex, cellWidths, onTableValue})}
                </Fragment>
              )
            })
          }
        </TableBody >
      )
    }
  }
  renderHeaderAction(tableHeaders) {
    const checkedItems = (this.props.allItems || this.props.items || []).filter(item => item._selected === true)
    const allActions = this.props.checkBoxActions ? this.props.checkBoxActions(checkedItems) : []
    if (!this.props.displayCheckBoxTable || allActions.length < 1) return (null)
    const visibleCheckedCount = this.props.items.filter(item => item._selected).length
    const checkedAll = this.props.items.length > 0 && visibleCheckedCount === this.props.items.length
    return (
      <TableRow key={'selectAllCell'} className={css(Styles.checkBoxRow)}>
        <TableCell
          className={css([Styles.cellBody, Styles.checkboxCell, Styles.checkAllCell])}
          colSpan={tableHeaders.length + 1}
        >
          <div className={css(Styles.selectionRow)}>

            <div className={css(Styles.selectionInfo)}>
              <Checkbox
                onChange={(e) => {
                  const checked = e.target.checked
                  this.props.items.forEach(item => {
                    item._selected = checked
                  })

                  this.props.setItems([...this.props.items])
                }}
                name={'checkAllItems'} color='primary'
                checked={checkedAll}
              />

              You have selected {checkedItems.length} item(s)
            </div>

            <div className={css(Styles.selectionActions)}>
              {checkedItems.length > 0 &&
                allActions.map((action, index) => (
                  <span
                    key={index}
                    className={css(Styles.checkboxActionButton)}
                  >
                    {action}
                  </span>
                ))
              }
            </div>

          </div>
        </TableCell>
      </TableRow>
    )
  }
  renderCheckbox(current) {
    return (
      <TableCell key={current.id + 'checkbox'} className={css([Styles.cellBody, Styles.firstcellBody, Styles.checkboxCell])}>
        <Checkbox
          classes={{
            root: css(Styles.rowCheckBox),
          }}
          color='primary'
          onChange={(event) => this.onCheckboxChange(event, current)}
          checked={current._selected}
          // disabled={this.state.checkedAll || false}
        />
      </TableCell>
    )
  }

  onCheckboxChange = (event, current) => {
    current._selected = event.target.checked
    const updatedItems = [...this.props.items]
    this.props.setItems(updatedItems)
  }

  setUpMenuItems(current, index) {
    if (this.props.onMenuItems) {
      return <MenuItemsDropdown onMenuItems={this.props.onMenuItems} current={current} />
    }
  }

  setUpActions(current, index) {
    // this.headerActions - if any action is multi: actions.push('checkbox')
    // let isMulti = false
    // if (this.props.headerActions) {
    //   for (const action of this.props.headerActions) {
    //     if (action.multi) {
    //       isMulti = true;
    //       break;
    //     }
    //   }
    // }

    let actions = []
    if (this.props.onActions) {
      actions = Object.assign([], this.props.onActions(current))
    }
    // if (isMulti) {
    //   actions.push(this.addButtonCheckbox(current, index))
    // }
    return actions;
  }

  // addButtonCheckbox(current, index) {
  //   return (
  //     <Tooltip title='Check' placement='top-start' key={current.id + 'checkTT'}>
  //       <span className={css(AppStyles.entityTableLinkIcon, (current.__checked ? Styles.buttonSpanUnchecked : Styles.buttonSpanChecked))}>
  //         <i className='material-icons-outlined' color='blue' onClick={() => this.handleCheck(current, index)}>check_circle</i>
  //       </span>
  //     </Tooltip >
  //   )
  // }

  handleCheck(current, index) {
    let itemsList = [];
    itemsList = Object.assign([], this.props.items)
    if (itemsList[index].__checked && itemsList[index].__checked) {
      current.__checked = false
    } else {
      current.__checked = true
    }
    this.props.setItems(itemsList)
  }

  _renderTable() {
    return (
      <div className={css(Styles.divTable)}>
        <Table className={css(Styles.table)}>
          {this.renderHead()}
          {this.renderBody()}
        </Table>
      </div>
    )
  }
  render() {
    return (
      <div className={css(AppStyles.entityContent, Styles.content, this.props.droppableTableId ? Styles.showInFullHeight : '')}>
        {this.props.droppableTableId ?
          (
            <Droppable droppableId={this.props.droppableTableId}>
              {(provided) => (
                <div className={css(Styles.droppableSection)} {...provided.droppableProps} ref={provided.innerRef}>
                  {this._renderTable()}
                </div>
              )}
            </Droppable>
          ) : (
            this.props.items && this.props.items.length > 0 ?
              this._renderTable()
              :
              UiHelper.emptyView(this.props.emptyText)
          )
        }
        {this.props.nextPage &&
          (<NextPage
            itemCount={this.props.items.length}
            nextPageState={this.props.nextPageState}
            onNext={this.props.onNext}></NextPage>)}
      </div>
    );
  }
}
const Styles = (AppConfig.CUSTOM_STYLE || AppConfig.CUSTOM_STYLE_COMP.includes('TableComponent')) ? CustomTableComponentStyles : StyleSheet.create({
  content: {
    paddingBottom: 0
  },
  divTable: {
    display: 'block',
    overflowX: 'auto',
    width: '100%',
    '@media (max-width: 320px)': {
      maxWidth: 310,
    },
    '@media (max-width: 767px) and (min-width: 321px)': {
      maxWidth: 350,
    },
    '@media (min-width: 768px) and (max-width: 1021px)': {
      maxWidth: 750,
    },
  },
  table: {
    borderCollapse: 'separate',
    borderSpacing: '0 10px',
  },
  entityAddIcon: {
    fontSize: 36,
    color: 'black',
    cursor: 'pointer',
  },
  cellHead: {
    backgroundColor: 'white',
    color: '#9B9B9B',
    height: 38,
    fontSize: 16,
    fontWeight: 'bold',
    padding: '8px 8px 8px 8px',
  },
  cellBodyIcons: {
    borderTopRightRadius: 8,
    borderBottomRightRadius: 8,
  },
  cellBody: {
    backgroundColor: 'white',
    color: '#4A4A4A',
    minHeight: 72,
    border: '1px solid #FFFFFF',
    fontSize: 16,
    padding: '8px 8px 8px 8px',
  },
  firstcellBody: {
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8,
    paddingLeft: 20
  },
  divIcon: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start'
  },
  firstCheckHeaderCell:{
    borderTopLeftRadius: 16,
    borderBottomLeftRadius: 16
  },
  endCheckHeaderCell:{
    borderTopRightRadius: 16,
    borderBottomRightRadius: 16
  },
  checkBoxRow:{},
  checkAllCell:{},
  rowCheckBox:{},
  draggingRow:{
    display: 'table'
  },
  emptyViewMessage:{
    backgroundColor:'#dededecc'
  },
  fullCellBodyLoader:{
    borderRadius: 16
  },
  emptyMessageDnd:{
    background: '#fff'
  },
  emptyTableDnd:{
    minHeight: '20vh'
  },
  droppableSection: {},
  showInFullHeight: {},
  selectionRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    flexWrap: 'nowrap'
  },

  selectionInfo: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
  },

  selectionActions: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    flexShrink: 0,
  },
})



// WEBPACK FOOTER //
// ./src/common/components/TableComponent.js